<div
	class="fixed inset-0 z-50 flex items-center justify-center min-h-screen overflow-y-auto bg-white min-w-screen"
	role="dialog"
	aria-modal="true"
	aria-labelledby="modal-headline">
	<ng-content></ng-content>
</div>
